<template>
    <AuthenticationBasic
            :title="$t('authentication.registration')">
        <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="register">
            <div v-if="invitedRegistration">
                <SocialButtons class="mt-0" @google-click="googleRegistration" @facebook-click="facebookRegistration"
                               @apple-click="appleRegistration"></SocialButtons>
                <div class="text-center mt-3 font-weight-bold">or</div>
            </div>
            <!-- <v-text-field
                    v-if="!invitedRegistration"
                    v-model="subscription.name"
                    :rules="[$validations.required]"
                    class="mb-2"
                    required>
                <template v-slot:label>
                    {{ $t('authentication.subscriptionName') }}<sup>*</sup>
                </template>
            </v-text-field> -->
            <v-text-field
                    v-model="subscription.firstName"
                    :rules="[$validations.required]"
                    class="mb-2"
                    required>
                <template v-slot:label>
                    {{ $t('authentication.firstName') }}<sup>*</sup>
                </template>
            </v-text-field>
            <v-text-field
                    v-model="subscription.lastName"
                    :rules="[$validations.required]"
                    class="mb-2"
                    required>
                <template v-slot:label>
                    {{ $t('authentication.lastName') }}<sup>*</sup>
                </template>
            </v-text-field>
            <v-text-field
                    v-model="subscription.email"
                    :disabled="invitedRegistration"
                    :readonly="invitedRegistration"
                    :rules="[$validations.required, $validations.email]"
                    class="mb-2"
                    required>
                <template v-slot:label>
                    {{ $t('authentication.email') }}<sup>*</sup>
                </template>
            </v-text-field>
            <v-text-field
                    v-if="!invitedRegistration"
                    v-model="subscription.confirmEmail"
                    :rules="[$validations.required, $validations.email, emailShouldMatchRule]"
                    class="mb-2"
                    required>
                <template v-slot:label>
                    {{ $t('authentication.confirmEmail') }}<sup>*</sup>
                </template>
            </v-text-field>
            <v-text-field
                    v-model="subscription.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[$validations.required, $validations.password]"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="new-password"
                    required
                    @click:append="showPassword = !showPassword">
                <template v-slot:label>
                    {{ $t('authentication.password') }}<sup>*</sup>
                </template>
            </v-text-field>
            <v-text-field
                    v-model="subscription.confirmPassword"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[$validations.required, $validations.password, passwordConfirmationRule]"
                    :type="showPassword ? 'text' : 'password'"
                    required
                    @click:append="showPassword = !showPassword">
                <template v-slot:label>
                    {{ $t('authentication.confirmPassword') }}<sup>*</sup>
                </template>
            </v-text-field>
            <!-- <v-autocomplete
                    v-if="!invitedRegistration"
                    v-model="subscription.Timezone"
                    :items="timezones"
                    :rules="[$validations.required]"
                    item-text="DisplayName"
                    item-value="Id">
                <template v-slot:label>
                    {{ $t('settings.timezone') }}<sup>*</sup>
                </template>
            </v-autocomplete> -->
            <v-text-field
                    v-model="subscription.address"
                    :label="$t('authentication.address')"
                    class="mb-2"
                    required/>
            <MazPhoneNumberInput v-model="phoneNumber"
                                 :border-radius="0"
                                 :clear="false"
                                 :dark="isDark"
                                 :default-country-code="countryCode"
                                 :default-phone-number="subscription.phoneNumber"
                                 :error="errorPhone"
                                 :error-color="$vuetify.theme.currentTheme.error"
                                 :valid-color="$vuetify.theme.currentTheme.primary"
                                 class="phone-number"
                                 color="white"
                                 show-code-on-list
                                 @update="updatePhone">
                <template #icon>
                    <v-icon>mdi-menu-down</v-icon>
                </template>
            </MazPhoneNumberInput>
            <v-btn
                    :loading="loading"
                    block
                    class="elevation-5 mt-5 accentText--text"
                    color="accent"
                    large
                    @click="register">
                {{ $t('authentication.register') }}
            </v-btn>
            <div v-if="!invitedRegistration" class="mt-8 body-2">
                {{ $t('authentication.alreadyHaveAccount') }}
                <router-link :to="{name: 'login'}">{{ $t('authentication.logIn') }}</router-link>
            </div>
        </v-form>
    </AuthenticationBasic>
</template>

<script>
import AuthenticationBasic from "@/components/Authentication/AuthenticationBasic";
import SocialButtons from "@/components/Authentication/SocialButtons.vue";
import {googleProvider, initApple, initFbsdk} from "@/components/Authentication/authentication";
import {GRANT_TYPE_FACEBOOK, GRANT_TYPE_GOOGLE} from "@/helper/constants";

export default {
  name: "LoginContent",
  components: {SocialButtons, AuthenticationBasic},
  mounted() {
    this.$store.dispatch('logout');
    if (this.invitedRegistration) {
      this.getInvitedPersonMail();
      this.initFbsdk();
      this.initApple();
    } else {
      this.initTimezones();
    }
  },
  data() {
    return {
      valid: false,
      showPassword: false,
      timezones: [],
      errorPhone: false,
      phoneNumber: '',
      subscription: {
        subscriptionID: 1,
        email: '',
        address: '',
        phoneNumber: null
      },
      loading: false,
      countryCode: this.$store.getters.getUserCountry,
    };
  },
  watch: {
    userCountry(val) {
      this.countryCode = val;
    }
  },
  computed: {
    isDark() {
      return this.$store.getters.getTheme === 'dark';
    },
    userCountry() {
      return this.$store.getters.getUserCountry;
    },
    passwordConfirmationRule() {
      return () => (this.subscription.password === this.subscription.confirmPassword) || this.$t('errors.passwordsNotMatch');
    },
    emailShouldMatchRule() {
      return () => (this.subscription.email === this.subscription.confirmEmail) || this.$t('errors.emailsNotMatch');
    },
    invitedRegistration() {
      return this.$route.name === 'invitedRegistration';
    }
  },
  methods: {
    initFbsdk,
    initApple,
    register() {
      this.$refs.form.validate();
      if (!this.valid || this.errorPhone) {
        return;
      }
      this.loading = true;
      if (this.invitedRegistration) {
        const url = this.$store.getters.getUrl('organizationInvitationWithUser');
        this.subscription.ValidationCode = this.$route.params.token;
        this.axios.put(url, {...this.subscription, phoneNumber: this.phoneNumber}).then(() => {
          this.$router.push({name: 'login', params: {email: this.subscription.email}});
        }).finally(() => {
          this.loading = false;
        });
      } else {
        const url = this.$store.getters.account();
        this.axios.post(url, {...this.subscription, phoneNumber: this.phoneNumber}).then(() => {
          //this.$router.push({name: 'registrationPayment', params: {id: data.Result}});
          this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.registrationSuccessActivateAccount'),
          translate: false,
        });
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    getInvitedPersonMail() {
      const url = this.$store.getters.invitationInformation(this.$route.params.token);
      this.axios.get(url).then(({data}) => {
        this.subscription.email = data.Result.Email;
      }).catch(() => {
        this.$router.push({name: 'login'});
      });
    },
    initTimezones() {
      const url = this.$store.getters.getUrl('timezones');
      this.axios.get(url).then(({data}) => {
        this.timezones = data.Result;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const country = tz.substring(tz.indexOf('/') + 1);
        const timezone = this.timezones.filter((timezone) => timezone.DisplayName.includes(country));
        if (timezone.length) {
          this.subscription.Timezone = timezone[0].Id;
        }
      });
    },
    updatePhone(val) {
      if (val.phoneNumber) {
        this.errorPhone = !val.isValid;
        this.subscription.phoneNumber = val.e164;
        this.subscription.phoneNumber = val.nationalNumber;
      } else {
        this.errorPhone = false;
        //   this.subscription.phoneNumber = null;
      }
    },
    getUserCountry() {
      this.axios.get('https://ipinfo.io', {
        params: {
          token: '5ae842a4a8c3d9'
        }
      }).then(({data}) => {
        this.countryCode = data.country;
      });
    },
    googleRegistration() {
      const login = googleProvider.useGoogleLogin({
        flow: 'implicit',
        onSuccess: (res) => this.googleLoginSuccess(res.access_token),
        onError: (err) => console.error('Failed to login with google', err),
      });
      login();
    },
    async googleLoginSuccess(token) {
      this.$store.dispatch('setLoader', true);
      this.$store.dispatch('acceptInvitationThirdParty', {
        grantType: GRANT_TYPE_GOOGLE,
        accessToken: token,
        validationCode: this.$route.params.token
      }).then((response) => {
        if (response.status === 200) {
          this.$router.push({name: 'login'});
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.registrationSuccessful'),
          });
        }

      }).finally(() => {
        this.loading = false;
        this.$store.dispatch('setLoader', false);
      });
    },
    facebookRegistration() {
      window.FB.login((response) => {
        if (response.authResponse) {
          const authToken = response.authResponse.accessToken;
          this.$store.dispatch('setLoader', true);
          this.$store.dispatch('acceptInvitationThirdParty', {
            grantType: GRANT_TYPE_FACEBOOK,
            accessToken: authToken,
            validationCode: this.$route.params.token,
          }).then((response) => {
            if (response.status === 200) {
              this.$router.push({name: 'login'});
              this.$store.dispatch('addNotification', {
                type: 'success',
                message: this.$t('success.registrationSuccessful'),
              });
            }
          }).finally(() => {
            this.loading = false;
            this.$store.dispatch('setLoader', false);
          });
        }
      }, {scope: 'email public_profile'});
    },
    async appleRegistration() {
      let response = await window.AppleID.auth.signIn();
      let payload = {
        code: response.authorization.code,
        idToken: response.authorization.id_token,
        validationCode: this.$route.params.token
      };
      if (response.user) {
        payload.email = response.user.email;
        payload.firstName = response.user.name.firstName;
        payload.lastName = response.user.name.lastName;
      }
      this.$store.dispatch('acceptInvitationApple', payload).then((response) => {
        if (response.status === 200) {
          this.$router.push({name: 'login'});
          this.$store.dispatch('addNotification', {
            type: 'success',
            message: this.$t('success.registrationSuccessful'),
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "registration-content";
</style>